<template>
  <div>
    <h2 class="font-bold text-xl mb-6">Preview</h2>
    <p class="  p-4 caption-textbox font-semibold cursor-pointer">
      <span class="text-muted-g">
        Wishing you all a very Happy New Year. Get Flat 50% Off on selective
        producte.</span
      ><br />Buy Now -&nbsp;<a
        href="https://magitt.com/discount/product"
        target="_blank"
        class="underline"
        >https://magitt.com/discount/product</a
      >
    </p>
    <base-button
      block
      type="kotakblue"
      @click="showSchedule = true"
      class="mt-4"
      >TEST WHATSAPP
    </base-button>
    <div v-show="showSchedule">
      <b-form-group class="mt-6">
        <p class="font-bold mb-3">Schedule Campaign</p>
        <b-form-radio
          v-model="schedule"
          class="custom-control-inline cust-radio-btn"
          name="some-radios"
          value="A"
          ><p class="font-semibold">Send Immediately</p></b-form-radio
        >
        <b-form-radio
          v-model="schedule"
          class="custom-control-inline cust-radio-btn"
          name="some-radios"
          value="B"
          ><p class="font-semibold">Schedule for Later</p></b-form-radio
        >
      </b-form-group>

      <base-input label="Date picker" v-if="schedule === 'B'">
        <flat-picker
          placeholder="Select Date...."
          slot-scope="{ focus, blur }"
          @on-open="focus"
          @on-close="blur"
          :config="{ allowInput: true }"
          class="form-control datepicker"
        >
        </flat-picker>
      </base-input>
      <base-button block class="mt-3" type="primary" @click="editModal = true"
        >Select Community</base-button
      >
    </div>
  </div>
</template>
<script>
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
export default {
  components: {
    flatPicker
  },
  data() {
    return {
      schedule: "",
      showSchedule: false
    };
  }
};
</script>
